module.exports = __webpack_public_path__ + "img/liveclass.5420f4d8.png";